module.exports = __webpack_public_path__ + "static/media/banner-2.653e5a76.jpg";